/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/coins_3_medium'
export default icon
